/**
 * The label of a filter row that is not a package field's own (`recherche-sessions.md` §9,
 * plate `ApresCriteres`).
 *
 * Every filter control of the app is a package `TextField` or `Select` in its `snug` size -
 * 44 px at 16 px, the height of the « Plus de filtres » button the row carries - whose label
 * is 14 px, Regular, black, in sentence case - the design system's, and the alignment §9
 * asked for. A few labels head something that is not one field: a « Période »
 * over two dates, the « Trier par » beside the sort. They are written with this class, the
 * package's default label, so they cannot drift from the fields beside them.
 *
 * The bleu-nuit border that used to say « this filter is armed » is gone with the native
 * controls: the package field has no such state, and the chips under the row are what says
 * which filters are on.
 */
export const FILTER_LABEL_CLASS = 'font-normal text-noir text-small';
